import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import httpClient from "../request";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    redirect: "overview",
    children: [
      {
        path: "homePage",
        name: "homePage",
        meta: {
          isShow: true,
          title: "Home Page",
        },
        component: () => import("../views/HomePageView.vue"),
      },
      {
        path: process.env.BASE_URL + "leakDataOfDay",
        name: "leakDataOfDay",
        meta: {
          isShow: true,
          title: "泄漏电流日历史数据",
        },
        component: () => import("../views/LeakDataOfDayView.vue"),
      },
      {
        path: process.env.BASE_URL + "corrosionDataOfDay",
        name: "corrosionDataOfDay",
        meta: {
          isShow: true,
          title: "大气腐蚀日历史数据",
        },
        component: () => import("../views/CorrosionDataOfDayView.vue"),
      },
      {
        path: process.env.BASE_URL + "leakDataOfMonth",
        name: "leakDataOfMonth",
        meta: {
          isShow: true,
          title: "泄漏电流月历史数据",
        },
        component: () => import("../views/LeakDataOfMonthView.vue"),
      },
      {
        path: process.env.BASE_URL + "corrosionDataOfMonth",
        name: "corrosionDataOfMonth",
        meta: {
          isShow: true,
          title: "大气腐蚀月历史数据",
        },
        component: () => import("../views/CorrosionDataOfMonthView.vue"),
      },
      {
        path: "leakDashboard/:sensorNO",
        name: "leakDashboard",
        meta: {
          isShow: false,
          title: "单个泄漏电流传感器数据总览",
        },
        component: () => import("../views/LeakDashboardView.vue"),
      },
      {
        path: "corrosionDashboard/:sensorNO",
        name: "corrosionDashboard",
        meta: {
          isShow: false,
          title: "单个大气腐蚀传感器数据总览",
        },
        component: () => import("../views/CorrosionDashboardView.vue"),
      },
      {
        path: process.env.BASE_URL + "corrosionThickness",
        name: "corrosionThickness",
        meta: {
          isShow: false,
          title: "腐蚀厚度",
        },
        component: () => import("../views/CorrosionThicknessView.vue"),
      },
      {
        path: "overview",
        name: "overview",
        meta: {
          isShow: false,
          title: "数据总览",
        },
        component: () => import("../views/OverviewView.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  httpClient({
    url: "checkLogin",
    method: "get",
    withCredentials: true,
  }).then((res: any) => {
    if (!res.data.hasLoggedIn && to.path !== "/login") {
      const redirectURL =
        process.env.BASE_URL + to.fullPath.startsWith("/") ? to.fullPath.substring(1) : to.fullPath;
      next({
        name: "login",
        query: { redirectURL: encodeURIComponent(redirectURL) },
      }); //为避免redirect url里包含?等特殊字符，应该将redirect url进行转义
    } else {
      next();
    }
  });
});

export default router;
